import {
  EsopExerciseModel,
  QuickEsopPoolUpdateModel,
  QuickBonusTransactionModel,
  QuickBuybackTransactionModel,
  QuickConversionTransactionModel,
  QuickRoundTransactionModel,
  QuickSecondaryTransactionModel,
  QuickSplitTransactionModel,
} from "../pages/newQuickTransaction/RoundTransactionModel";
import { zustandState } from "./zustandState";

export const initialRoundState: QuickRoundTransactionModel = {
  eventId: "",
  stepNo: 1,
  roundType: "EXCEL",
  transactionType: "round",
  companyId: "",
  fileName: "",
  fileType: {
    name: "",
    size: 0,
    type: "",
  },
  newRoundDetails: undefined,
  newRoundInput: undefined,
  conversion: [],
  antiDilutionSecurities: [],
};

const initialSecondaryState: QuickSecondaryTransactionModel = {
  eventId: "",
  stepNo: 1,
  companyId: "",
  transactionType: "secondary",
  name: undefined,
  date: undefined,
  secondaryTransactions: [],
};
const initialBonusState: QuickBonusTransactionModel = {
  eventId: "",
  stepNo: 1,
  transactionType: "bonus",
  companyId: "",
  bonusName: "",
  targetPPS: "",
  bonusRatio: "",
  applicableForAllSecurities: true,
  date: "",
  quickBonusTransactions: [],
};

const initialBuybackState: QuickBuybackTransactionModel = {
  eventId: "",
  companyId: "",
  quickBuybackInput: undefined,
  stepNo: 1,
  transactionType: "buyback",
};
const initialSplitState: QuickSplitTransactionModel = {
  eventId: "",
  stepNo: 1,
  transactionType: "split",
  companyId: "",
  quickSplitInput: undefined,
};
const initialConversionState: QuickConversionTransactionModel = {
  eventId: "",
  stepNo: 1,
  transactionType: "conversion",
  companyId: "",
  quickConversionInput: undefined,
};
const initialEsopExerciseState: EsopExerciseModel = {
  eventId: "",
  stepNo: 1,
  transactionType: "exercise",
  companyId: "",
  esopExerciseDetails: undefined,
};
const initialEsopPoolUpdateState: QuickEsopPoolUpdateModel = {
  eventId: "",
  stepNo: 1,
  transactionType: "esopPool",
  companyId: "",
  date: "",
  updateMode: "shares",
  shares: "",
  percentage: "",
  decreasePool: false,
};

export const useQuickRoundTransactionStore = zustandState(initialRoundState);
export const useQuickSecondaryTransactionStore = zustandState(
  initialSecondaryState
);
export const useQuickBonusTransactionStore = zustandState(initialBonusState);
export const useQuickBuybackTransactionStore =
  zustandState(initialBuybackState);
export const useQuickSplitTransactionStore = zustandState(initialSplitState);
export const useQuickConversionTransactionStore = zustandState(
  initialConversionState
);
export const useQuickEsopExerciseTransactionStore = zustandState(
  initialEsopExerciseState
);
export const useQuickEsopPoolUpdateTransactionStore = zustandState(
  initialEsopPoolUpdateState
);
